
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import request from "@/lib/request/request";

interface VirItem {
  virId: number;
  name: string;
  voiceType: string;
  coverUrl: string;
  videoUrl?: string;
  canUse?: number;
  isDefault?: number;
}

@Component({
  components: {
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class examRoomStyle extends Vue {
  @Prop() formItemData!: any; // 组件数据

  virVersionList: VirItem[] = [];

  rules = {};

  chooseVirVersion = 0;

  get chooseVirName() {
    return (
      this.virVersionList.find(vir => vir.virId === this.chooseVirVersion)
        ?.name || ""
    );
  }

  curIndex = 0;
  slider(pos: string) {
    const virsContainer = this.$refs.virsContainer as HTMLElement;
    if (!virsContainer) {
      return;
    }
    this.curIndex = this.curIndex + (pos === "right" ? 1 : -1);
    if (this.curIndex < 0) {
      this.curIndex = 0;
    } else if (this.curIndex > this.virVersionList.length - 2) {
      this.curIndex = this.virVersionList.length - 2;
    }
    virsContainer.scrollTo({
      left: 180 * this.curIndex + this.curIndex * 20,
      behavior: "smooth"
    });
  }

  chooseVir(vir: VirItem) {
    this.chooseVirVersion = this.formItemData.virConfig.virId = vir.virId;
  }

  preview(vir: VirItem) {
    this.$emit("preview", vir.videoUrl);
  }

  raf = 0;
  hasScroll = false;
  calcHasScroll() {
    if (this.raf) {
      return;
    }
    this.raf = requestAnimationFrame(() => {
      this.raf = 0;
      const virsContainer = this.$refs.virsContainer as HTMLElement;
      if (!virsContainer) {
        return;
      }
      // this.hasScroll = virsContainer.scrollWidth > virsContainer.clientWidth;
      this.hasScroll = this.virVersionList.length > 3;
    });
  }

  // 校验数据：
  //    (1) 校验不通过，返回 false
  //    (2) 校验通过，返回 true
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }

  async getVirVersionList() {
    const res = await request.postInterviewApi("hr/company/virVersions");
    this.virVersionList = res.data.data.virVersionList;
    this.formItemData.virConfig.virId = this.chooseVirVersion =
      this.formItemData.virConfig.virId || this.virVersionList[0].virId;
  }

  mounted() {
    this.getVirVersionList();
    this.calcHasScroll();
    // window.addEventListener('resize', this.calcHasScroll)
  }

  beforeDestory() {
    // window.removeEventListener('resize', this.calcHasScroll)
  }
}
